import { render, staticRenderFns } from "./FreeBlock.vue?vue&type=template&id=68a367b7&scoped=true"
import script from "./FreeBlock.vue?vue&type=script&lang=ts"
export * from "./FreeBlock.vue?vue&type=script&lang=ts"
import style0 from "./FreeBlock.vue?vue&type=style&index=0&id=68a367b7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a367b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68a367b7')) {
      api.createRecord('68a367b7', component.options)
    } else {
      api.reload('68a367b7', component.options)
    }
    module.hot.accept("./FreeBlock.vue?vue&type=template&id=68a367b7&scoped=true", function () {
      api.rerender('68a367b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reminder-layout-editor/FreeBlock.vue"
export default component.exports